import config from "./routes";

const customs =  {
  SUPPORTED_LANGUAGES: ["es"],
  DEFAULT_LANGUAGE: "es",
  MONEY_SYMBOL: "$",
  MONEY_CODE: "u$s",
  MONEY_POSITION: "prefix", //'sufix'
  MONEY_SPACE: true,
  CURRENCIES: ["USD", "ARS"],
  CURRENCY: "ARS",
  LOCALE: "es-ES",
  USER_TYPE: {
    REGULAR: 'regular',
    ADVANCED: 'advanced',
    PATIENT: 'patient',
    PROFESSIONAL: 'professional',
    PHARMACY: 'pharmacy',
  },
  USER_REGISTER_ACTIVATION_REQUIRED: true,
  USER_ACCOUNTS_INTEGRATED: true,
  USER_ACCOUNTS: {
    TYPES: {
      OWNER: "owner",
      GUEST: "guest",
    },
    STATUS: {
      ACTIVE: "active",
      INACTIVE: "inactive",
      REVOKED: "revoked",
    },
  },
  OWNER: {
    SYSTEM: "system"
  },
  OPTIONS: {
    SINGUP: {
      GENDER:
      {
        TYPES: ['masculino', 'femenino', 'otro']
      },
      IDENTIFICATION:
      {
        TYPES: ['DNI', 'LE', 'LC', 'DNI Internacional']
      },
      SPECIALTIES:
      {
        TYPES: ['Alergia e inmunologia', 'Anatomia patologica', 'Anestesiologia', 'Angiologia general y hemodinamia', 'Cardiologia', 'Cardiologo infantil', 'Cirugia cardiovascular', 'Cirugia de cabeza y cuello', 'Cirugia de torax (cirugia toracica)', 'Cirugia general', 'Cirugia infantil (cirugia pediatrica)', 'Cirugia plastica y reparadora', 'Cirugia vascular periferica', 'Clinica medica', 'Coloproctologia', 'Dermatologia', 'Diagnostico por imagenes', 'Endocrinologia', 'Endocrinologo infantil', 'Farmacologia clinica', 'Fisiatria (medicina fisica y rehabilitacion)', 'Gastroenterologia', 'Gastroenterologo infantil', 'Genetica medica', 'Geriatria', 'Ginecologia', 'Hematologia', 'Hematologo infantil', 'Hemoterapia e inmunohematologia', 'Infectologia', 'Infectologo infantil', 'Medicina del deporte', 'Medicina del trabajo', 'Medicina general y/o medicina de familia', 'Medicina legal', 'Medicina nuclear', 'Nefrologia', 'Nefrologo infantil', 'Neonatologia', 'Neumonologia', 'Neumonologo infantil', 'Neurocirugia', 'Neurologia', 'Neurologo infantil', 'Nutricion', 'Obstetricia', 'Oftalmologia', 'Oncologia', 'Oncologo infantil', 'Ortopedia y traumatologia', 'Otorrinolaringologia', 'Pediatria', 'Psiquiatria', 'Psiquiatria infanto juvenil', 'Radioterapia o terapia radiante', 'Reumatologia', 'Reumatologo infantil', 'Terapia intensiva', 'Terapista intensivo infantil', 'Tocoginecologia', 'Toxicologia', 'Urologia']
      },  
    }
  },
  POINTS: {
    unit : '',
    factor: 1,
  },
  TYPES: {
    SERVICES: "services",
    ACTIVE: 'active',
    USER_ASSOCIATION: {
      PATIENT_PROFESSIONAL: 'patient'
    }, 
  },
  APPOINTMENTS: [
    { icon: 'video_camera', type: 'video', label: 'Videollamadas', detail: '', need_booking: true },
    { icon: 'door', type: 'visit', label: 'Visita al consultorio', detail: '', need_booking: true },
    { icon: 'chat_alt', type: 'message', label: 'Mensajería', detail: '', need_booking: false },
  ],
  PRESCRIPTIONS: {
    TYPE: {
      PHARMACY: 'pharmacy',
      INDICATIONS: 'indications',
    },
    STATUS: {
      ACTIVE: 'active',
      INACTIVE: 'inactive',
    }
  },

  MESSAGES: {
    TYPE: {
      MESSAGE: "message",
      NOTIFICATION: "notification",
    },
    CONFIG: {
      BOOK: {
        BODY: 'solicitó un nuevo turno',
      }
    }
  },

  TRANSACTIONS: {
    BOOK: {
      TYPE: 'book',
      SUB_TYPE: {
        VIDEO: 'video',
        VISIT: 'visit',
        MESSAGE: 'message',
      },
      STATUS: {
        BOOKED: 'booked',
        CANCELED: 'canceled',
        COMPLETED: 'completed',
        IN_PROGRESS: 'in_progress'
      }
    },
    PURCHASE: {
      TYPE: 'purchase',
      SUB_TYPE: {
        PHARMACY: 'pharmacy',
      },
      STATUS: {
        OPEN: 'open',
        CANCELED: 'canceled',
        COMPLETED: 'completed'
      }
    },
  },
  SIDEBAR: {
    MENU: {
      MAIN: [
        { icon: 'home', label: 'Inicio', route: config.ROUTES.HOME },
        { icon: 'stethoscope', label: 'Consultas profesionales', route: config.ROUTES.APPOINTMENTS.LIST },
        { icon: 'clipboard_list', label: 'Recetas', route: config.ROUTES.PRESCRIPTIONS },
        { icon: 'shopping_bag', label: 'Pedidos', route: config.ROUTES.PURCHASES.LIST },
        { icon: 'identification', label: 'Historia Clínica', route: config.ROUTES.HISTORY },
        { icon: 'chat_alt', label: 'Mensajes', route: config.ROUTES.MESSAGES },
        // { icon: 'bell', label: 'Notificaciones', route: config.ROUTES.NOTIFICATIONS },

      ],
      SECONDARY: [
        { /* icon: 'help',*/ label: 'How works?', route: config.ROUTES.HOW_WORKS },
        { /*icon: 'phone',*/ label: 'Contact us', route: config.ROUTES.CONTACT_US },
        { /*icon: '',*/ label: 'Terms and conditions', route: config.ROUTES.TERMS },
        { /*icon: '',*/ label: 'Privacy policies', route: config.ROUTES.PRIVACY },
      ],
      ADMIN: [
      ],
    },
  },
  SLIDER: {
    SHOW: true,
    CONTENT: [
      {
        title: "Busca tu profesional de confianza",
        body: "Seleccioná dentro del listado de especialistas",
        button: "Next",
      },
      {
        title: "Selecciona un turno médico",
        body: "Elegí la modalidad, día y horario de tu consulta.",
        button: "Next",
      },
      {
        title: "Administrá tus recetas",
        body: "Compra tus medicamentos fácilmente desde cualquier lugar",
        button: "Start",
      },
    ],
  },
  TRANSLATE: {
    TIME_REMAINS: 'alrededor de',
    CLINIC_HISTORY: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore 
    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut 
    aliquip ex ea commodo consequat.`
  },
  MINUTES: {
    TO_CANCEL: 300,
    BEFORE_ATTEND: 15,
    AFTER_ATTEND: 10,
  }
};
export default customs;
